import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';
import type { Address } from '@/api/place/types';

export const useLocationStore = create(
  devtools(
    combine(
      {
        loading: false as boolean,
        address: null as Address | null,
        isHub: false as boolean,
        cityId: '' as string,
        city: '' as string,
      },
      (set) => ({
        setDetectingLocation: (loading: boolean) => {
          set({ loading });
        },
        setAddress: (address: Address | null) => {
          set({ address });
        },
        setIsHub: (isHub: boolean) => {
          set({ isHub });
        },
        setCityId: (cityId: string) => {
          set({ cityId });
        },
        setCity: (city: string) => {
          set({ city });
        },
        resetLocationStore: () => {
          set({ loading: false, address: null, cityId: '', city: '' });
        },
      })
    )
  )
);
